<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">CONTACTOS</h1>
      <p class="text-gray-600 dark:text-gray-400">CATÁLOGO DE CONTACTOS (PERSONAS FÍSICAS Y MORALES)</p>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <div class="flex justify-between items-center">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">LISTA DE CONTACTOS</h2>
          <button @click="openModal()" class="bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            NUEVO CONTACTO
          </button>
        </div>
        <div class="flex flex-wrap gap-2 mt-4">
          <input
            v-model="filtros.buscar"
            @keyup.enter="buscarContactos"
            type="text"
            placeholder="BUSCAR POR NOMBRE, RAZÓN SOCIAL, EMAIL, RFC O TELÉFONO..."
            class="px-3 py-2 rounded border text-sm bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200 uppercase placeholder:normal-case"
          />
          <select
            v-model="filtros.estatus"
            @change="buscarContactos"
            class="px-3 py-2 rounded border text-sm bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200"
          >
            <option value="">TODOS LOS ESTATUS</option>
            <option value="activo">ACTIVO</option>
            <option value="inactivo">INACTIVO</option>
          </select>
          <button @click="buscarContactos" class="px-4 py-2 rounded bg-violet-600 text-white text-sm font-semibold hover:bg-violet-700 transition">BUSCAR</button>
          <button @click="limpiarFiltros" class="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-sm font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition">LIMPIAR</button>
        </div>
      </div>

      <div class="p-6">
        <div v-if="error" class="text-red-500 text-center mb-4">{{ error }}</div>
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs uppercase bg-gray-100 dark:bg-gray-800 dark:text-gray-300 border-b-2 border-gray-200 dark:border-gray-700">
              <tr>
                <th class="px-4 py-2 font-bold">TIPO</th>
                <th class="px-4 py-2 font-bold">NOMBRE / RAZÓN SOCIAL</th>
                <th class="px-4 py-2 font-bold">RFC</th>
                <th class="px-4 py-2 font-bold">EMAIL</th>
                <th class="px-4 py-2 font-bold">TELÉFONO</th>
                <th class="px-4 py-2 font-bold">ESTATUS</th>
                <th class="px-4 py-2 font-bold">ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="contacto in contactos" :key="contacto.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 even:bg-gray-50 dark:even:bg-gray-700">
                <td class="px-4 py-2">
                  <span
                    :class="contacto.tipo_contacto === 'mixto' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300' : (contacto.tipo_contacto === 'fiscal' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300' : 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300')"
                    class="px-2 py-1 text-xs font-medium rounded-full"
                  >
                    {{ contacto.tipo_contacto === 'mixto' ? 'MIXTO' : (contacto.tipo_contacto === 'fiscal' ? 'FISCAL' : 'PERSONAL') }}
                  </span>
                </td>
                <td class="px-4 py-2 font-medium text-gray-900 dark:text-white uppercase">{{ contacto.nombre_completo }}</td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200 uppercase">{{ contacto.rfc || '-' }}</td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200">{{ contacto.email }}</td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200">{{ contacto.telefono }}</td>
                <td class="px-4 py-2">
                  <span
                    :class="contacto.estatus === 'activo' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'"
                    class="px-2 py-1 text-xs font-medium rounded-full"
                  >
                    {{ contacto.estatus === 'activo' ? 'ACTIVO' : 'INACTIVO' }}
                  </span>
                </td>
                <td class="px-4 py-2">
                  <div class="flex gap-2">
                    <button @click="openModal(contacto)" class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                    </button>
                    <button @click="eliminarContacto(contacto)" class="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="contactos.length === 0">
                <td colspan="7" class="px-4 py-8 text-center text-gray-500 dark:text-gray-400">NO SE ENCONTRARON CONTACTOS</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div v-if="pagination.total > 0" class="flex justify-between items-center mt-6">
          <div class="text-sm text-gray-700 dark:text-gray-300">
            Mostrando {{ ((pagination.current_page - 1) * pagination.per_page) + 1 }} a {{ Math.min(pagination.current_page * pagination.per_page, pagination.total) }} de {{ pagination.total }} contactos
          </div>
          <div class="flex gap-2">
            <button @click="cambiarPagina(pagination.current_page - 1)" :disabled="pagination.current_page <= 1"
              class="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-sm hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed">
              Anterior
            </button>
            <span class="px-3 py-1 text-sm text-gray-700 dark:text-gray-300">
              Página {{ pagination.current_page }} de {{ pagination.last_page }}
            </span>
            <button @click="cambiarPagina(pagination.current_page + 1)" :disabled="pagination.current_page >= pagination.last_page"
              class="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-sm hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed">
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-bold text-gray-900 dark:text-white">
            {{ editingContacto ? 'EDITAR CONTACTO' : 'NUEVO CONTACTO' }}
          </h3>
          <button @click="closeModal" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <form @submit.prevent="submitForm">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

            <!-- DATOS FISCALES -->
            <div class="md:col-span-2">
              <h4 class="text-sm font-bold text-gray-700 dark:text-gray-300 uppercase mb-3 border-b dark:border-gray-700 pb-2 tracking-wider">
                DATOS FISCALES (OPCIONAL)
              </h4>
            </div>

            <div class="md:col-span-2">
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">RAZÓN SOCIAL</label>
              <input v-model="form.razon_social" type="text" maxlength="100"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">RFC</label>
              <input v-model="form.rfc" type="text" maxlength="13"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <!-- DATOS PERSONALES -->
            <div class="md:col-span-2">
              <h4 class="text-sm font-bold text-gray-700 dark:text-gray-300 uppercase mb-3 mt-2 border-b dark:border-gray-700 pb-2 tracking-wider">
                DATOS PERSONALES (OPCIONAL)
              </h4>
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">NOMBRE</label>
              <input v-model="form.nombre" type="text" maxlength="50"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">APELLIDO PATERNO</label>
              <input v-model="form.apellido_paterno" type="text" maxlength="50"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">APELLIDO MATERNO</label>
              <input v-model="form.apellido_materno" type="text" maxlength="50"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <!-- INFORMACIÓN DE CONTACTO -->
            <div class="md:col-span-2">
              <h4 class="text-sm font-bold text-gray-700 dark:text-gray-300 uppercase mb-3 mt-2 border-b dark:border-gray-700 pb-2 tracking-wider">
                INFORMACIÓN DE CONTACTO
              </h4>
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">TELÉFONO <span class="text-red-500">*</span></label>
              <input v-model="form.telefono" type="tel" required maxlength="20"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white" />
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">EMAIL <span class="text-red-500">*</span></label>
              <input v-model="form.email" type="email" required maxlength="50"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white" />
            </div>

            <!-- DIRECCIÓN -->
            <div class="md:col-span-2">
              <h4 class="text-sm font-bold text-gray-700 dark:text-gray-300 uppercase mb-3 mt-2 border-b dark:border-gray-700 pb-2 tracking-wider">
                DIRECCIÓN
              </h4>
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">CALLE</label>
              <input v-model="form.calle" type="text" maxlength="50"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">NÚMERO</label>
              <input v-model="form.numero" type="text" maxlength="10"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <div class="md:col-span-2">
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">ENTRE CALLES</label>
              <input v-model="form.entre_calles" type="text" maxlength="100"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">COLONIA</label>
              <input v-model="form.colonia" type="text" maxlength="50"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">MUNICIPIO</label>
              <input v-model="form.municipio" type="text" maxlength="50"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">ESTADO</label>
              <input v-model="form.estado" type="text" maxlength="50"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white uppercase" />
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">CÓDIGO POSTAL</label>
              <input v-model="form.codigo_postal" type="text" maxlength="10"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white" />
            </div>

            <!-- DATOS DE FACTURACIÓN -->
            <div class="md:col-span-2">
              <h4 class="text-sm font-bold text-gray-700 dark:text-gray-300 uppercase mb-3 mt-2 border-b dark:border-gray-700 pb-2 tracking-wider">
                DATOS DE FACTURACIÓN
              </h4>
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">USO DE CFDI</label>
              <select v-model="form.uso_cfdi_id"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white">
                <option :value="null">— SIN USO CFDI —</option>
                <option v-for="u in catalogos.usosCfdi" :key="u.id" :value="u.id">
                  {{ u.clave }} — {{ u.descripcion.toUpperCase() }}
                </option>
              </select>
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">TIPO DE PAGO</label>
              <select v-model="form.tipo_pago_id"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white">
                <option :value="null">— SIN TIPO DE PAGO —</option>
                <option v-for="t in catalogos.tiposPago" :key="t.id" :value="t.id">
                  {{ t.descripcion.toUpperCase() }}
                </option>
              </select>
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">FORMA DE PAGO</label>
              <select v-model="form.forma_pago_id"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white">
                <option :value="null">— SIN FORMA DE PAGO —</option>
                <option v-for="f in catalogos.formasPago" :key="f.id" :value="f.id">
                  {{ f.descripcion.toUpperCase() }}
                </option>
              </select>
            </div>

            <!-- INFORMACIÓN ADICIONAL -->
            <div class="md:col-span-2">
              <h4 class="text-sm font-bold text-gray-700 dark:text-gray-300 uppercase mb-3 mt-2 border-b dark:border-gray-700 pb-2 tracking-wider">
                INFORMACIÓN ADICIONAL
              </h4>
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">ESTATUS</label>
              <select v-model="form.estatus"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white">
                <option value="activo">ACTIVO</option>
                <option value="inactivo">INACTIVO</option>
              </select>
            </div>

            <div class="md:col-span-2">
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">NOTAS</label>
              <textarea v-model="form.notas" rows="3"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white"></textarea>
            </div>
          </div>

          <div class="flex justify-end gap-3 mt-6">
            <button type="button" @click="closeModal"
              class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-600">
              CANCELAR
            </button>
            <button type="submit" :disabled="loading"
              class="px-4 py-2 text-sm font-medium text-white bg-violet-600 border border-transparent rounded-md hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500 disabled:opacity-50">
              {{ loading ? 'GUARDANDO...' : (editingContacto ? 'ACTUALIZAR' : 'CREAR') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useHttp } from '@/composables/useHttp.js';
import Swal from 'sweetalert2';

const { get, post, put, delete: del, data } = useHttp();
const httpCats = useHttp();

const contactos = ref([]);
const loading   = ref(false);
const error     = ref('');
const showModal = ref(false);
const editingContacto = ref(null);

const catalogos = ref({ usosCfdi: [], tiposPago: [], formasPago: [] });

const filtros = ref({ buscar: '', estatus: '' });

const pagination = ref({ current_page: 1, last_page: 1, per_page: 15, total: 0 });

const emptyForm = () => ({
  razon_social:     '',
  rfc:              '',
  nombre:           '',
  apellido_paterno: '',
  apellido_materno: '',
  telefono:         '',
  email:            '',
  calle:            '',
  numero:           '',
  entre_calles:     '',
  colonia:          '',
  municipio:        '',
  estado:           '',
  codigo_postal:    '',
  uso_cfdi_id:      null,
  tipo_pago_id:     null,
  forma_pago_id:    null,
  estatus:          'activo',
  notas:            '',
});

const form = ref(emptyForm());

const resetForm = () => { form.value = emptyForm(); };

const openModal = (contacto = null) => {
  editingContacto.value = contacto;
  form.value = contacto
    ? {
        ...emptyForm(),
        ...contacto,
        uso_cfdi_id:  contacto.uso_cfdi_id  ?? null,
        tipo_pago_id: contacto.tipo_pago_id ?? null,
        forma_pago_id: contacto.forma_pago_id ?? null,
      }
    : emptyForm();
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  editingContacto.value = null;
  resetForm();
};

const cargarCatalogos = async () => {
  try {
    await httpCats.get('/usos-cfdi');
    catalogos.value.usosCfdi = httpCats.data.value ?? [];

    await httpCats.get('/tipos-pago');
    catalogos.value.tiposPago = httpCats.data.value ?? [];

    await httpCats.get('/formas-pago');
    catalogos.value.formasPago = httpCats.data.value ?? [];
  } catch {
    // catálogos vacíos si falla
  }
};

const cargarContactos = async (pagina = 1) => {
  try {
    loading.value = true;
    error.value = '';

    const params = new URLSearchParams({ page: pagina, per_page: pagination.value.per_page });
    if (filtros.value.buscar)  params.append('buscar',  filtros.value.buscar);
    if (filtros.value.estatus) params.append('estatus', filtros.value.estatus);

    await get(`/contactos?${params}`);
    contactos.value = data.value.data;
    pagination.value = {
      current_page: data.value.current_page,
      last_page:    data.value.last_page,
      per_page:     data.value.per_page,
      total:        data.value.total,
    };
  } catch (err) {
    error.value = err?.data?.value?.data?.message || 'ERROR AL CARGAR CONTACTOS';
  } finally {
    loading.value = false;
  }
};

const buscarContactos = () => cargarContactos(1);

const limpiarFiltros = () => {
  filtros.value = { buscar: '', estatus: '' };
  cargarContactos(1);
};

const cambiarPagina = (pagina) => {
  if (pagina >= 1 && pagina <= pagination.value.last_page) cargarContactos(pagina);
};

const submitForm = async () => {
  try {
    loading.value = true;

    if (editingContacto.value) {
      await put(`/contactos/${editingContacto.value.id}`, form.value);
      Swal.fire('¡Éxito!', 'Contacto actualizado correctamente', 'success');
    } else {
      await post('/contactos', form.value);
      Swal.fire('¡Éxito!', 'Contacto creado correctamente', 'success');
    }

    closeModal();
    cargarContactos(pagination.value.current_page);
  } catch (err) {
    const message = err.response?.data?.message || 'Error al procesar la solicitud';
    Swal.fire('Error', message, 'error');
  } finally {
    loading.value = false;
  }
};

const eliminarContacto = async (contacto) => {
  try {
    const result = await Swal.fire({
      title: '¿ESTÁS SEGURO?',
      text: `¿DESEAS ELIMINAR EL CONTACTO ${contacto.nombre_completo?.toUpperCase()}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'SÍ, ELIMINAR',
      cancelButtonText: 'CANCELAR',
    });

    if (result.isConfirmed) {
      await del(`/contactos/${contacto.id}`);
      Swal.fire('¡ELIMINADO!', 'Contacto eliminado correctamente', 'success');
      cargarContactos(pagination.value.current_page);
    }
  } catch (err) {
    const message = err.response?.data?.message || 'Error al eliminar contacto';
    Swal.fire('Error', message, 'error');
  }
};

onMounted(() => {
  cargarCatalogos();
  cargarContactos();
});
</script>
